module.exports = __webpack_public_path__ + "statics/img/FullChain-3@2x.dcae95fc.png";